// ABOUTME: The chat card for an image edited from chat. The message keeps only the edit's Library
// asset; the card shows it by the signed URL the media API hands out on each read (a signature
// kept in the persisted chat would expire) and offers Edit on that URL.

import { useQuery } from '@tanstack/react-query'
import { PencilLine } from 'lucide-react'

import { getAsset } from '@/api/media'
import { ContentLinkButton } from '@/components/chat/ContentLinkButton'
import { Button } from '@/components/ui/button'

interface EditedImageCardProps {
  assetId: string
  readOnly: boolean
  onEditImage?: (imageUrl: string) => void
}

export function EditedImageCard({ assetId, readOnly, onEditImage }: EditedImageCardProps) {
  const asset = useQuery({ queryKey: ['asset', assetId], queryFn: () => getAsset(assetId) })
  const url = asset.data?.public_url ?? null
  return (
    <div className="mt-1 flex w-full items-center gap-2">
      <div className="min-w-0 flex-1">
        <ContentLinkButton
          to="/content"
          label="View on the Content page"
          title="Image generated"
          thumbUrl={url}
          data-testid="generated-image-card"
        />
      </div>
      {!readOnly && onEditImage && (
        <Button
          variant="outline"
          size="icon-touch"
          className="shrink-0"
          disabled={!url}
          onClick={() => url && onEditImage(url)}
          aria-label="Edit image"
          data-testid="edit-image-button"
        >
          <PencilLine className="size-4" />
        </Button>
      )}
    </div>
  )
}
